import { FC } from 'react';

interface PaginationControlsProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  keyPrefix?: string;
  className?: string;
  maxVisiblePages?: number;
}

export const PaginationControls: FC<PaginationControlsProps> = ({
  page,
  totalPages,
  onPageChange,
  keyPrefix = 'page',
  className = 'mt-6',
  maxVisiblePages,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const buildVisiblePages = () => {
    if (!maxVisiblePages || maxVisiblePages < 3 || totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const sideCount = Math.max(0, Math.floor((maxVisiblePages - 3) / 2));
    const start = Math.max(2, page - sideCount);
    const end = Math.min(totalPages - 1, page + sideCount);

    const pages: Array<number | 'ellipsis-left' | 'ellipsis-right'> = [1];

    if (start > 2) {
      pages.push('ellipsis-left');
    }

    for (let pageNumber = start; pageNumber <= end; pageNumber += 1) {
      pages.push(pageNumber);
    }

    if (end < totalPages - 1) {
      pages.push('ellipsis-right');
    }

    pages.push(totalPages);
    return pages;
  };

  const visiblePages = buildVisiblePages();

  return (
    <div className={`${className} flex flex-wrap items-center justify-center gap-2`}>
      <button
        type="button"
        className="rounded-[10px] border border-[#E6E6E6] px-3 py-1 text-sm text-grey2 disabled:opacity-50"
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
      >
        Назад
      </button>
      {visiblePages.map((item, index) => {
        if (typeof item !== 'number') {
          return (
            <span key={`${keyPrefix}-ellipsis-${index}`} className="px-2 text-sm text-grey2">
              ...
            </span>
          );
        }

        return (
          <button
            key={`${keyPrefix}-${item}`}
            type="button"
            className={`rounded-[10px] border px-3 py-1 text-sm ${
              item === page
                ? 'border-blackBase bg-blackBase text-white'
                : 'border-[#E6E6E6] text-grey2 hover:text-blackBase'
            }`}
            onClick={() => onPageChange(item)}
          >
            {item}
          </button>
        );
      })}
      <button
        type="button"
        className="rounded-[10px] border border-[#E6E6E6] px-3 py-1 text-sm text-grey2 disabled:opacity-50"
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
      >
        Вперед
      </button>
    </div>
  );
};
